var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432 144C440.837 144 448 151.163 448 160C448 168.731 441.006 175.829 432.315 175.997L432 176H80C71.1634 176 64 168.837 64 160C64 151.269 70.9939 144.171 79.6851 144.003L80 144H432ZM432 240C440.837 240 448 247.163 448 256C448 264.731 441.006 271.829 432.315 271.997L432 272H80C71.1634 272 64 264.837 64 256C64 247.269 70.9939 240.171 79.6851 240.003L80 240H432ZM448 352C448 343.163 440.837 336 432 336H80L79.6851 336.003C70.9939 336.171 64 343.269 64 352C64 360.837 71.1634 368 80 368H432L432.315 367.997C441.006 367.829 448 360.731 448 352Z",
    fill: "#222428"
  })));
};

export { SvgMenu as ReactComponent };
export default __webpack_public_path__ + "static/media/images/menu.svg";